import type { CoreApiClient } from "../client";
import { createAirHandlerUnitMutations } from "../mutations/air-handler-unit.mutations";
import { createAirHandlerUnitQueries } from "../queries/air-handler-unit.queries";

export const createAirHandlerUnitRepository = (api: CoreApiClient) => ({
  ...createAirHandlerUnitQueries(api),
  ...createAirHandlerUnitMutations(api),
});
